export default __webpack_public_path__ + "static/SR France - Etiquetage des Caramels Colorants - Note d'information-514d241fc3f7d74cb19567647bce9a75.pdf";